const verifyDecimals = value => {
  const decimals = `${value}`.substring(2);
  return decimals.length <= 4;
};

export default verifyDecimals;
